import { NewMarqueeComponentHomePageIndia } from '../qbStrap'

const entertainmentClients = [
    { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg", altText: "Shivalaya 1" },
    { imgSrc: "/assets/themePark_icons/dizzie.svg", altText: "Dizzee World" },
    { imgSrc: "/assets/themePark_icons/sgnp.svg", altText: "SGNP" },
    { imgSrc: "/assets/themePark_icons/kochui.svg", altText: "Kochi" },
    { imgSrc: "/assets/themePark_icons/escape.svg", altText: "Escape Water Park" },
    { imgSrc: "/assets/themePark_icons/vedvan.svg", altText: "Vedvan" },
    { imgSrc: "/assets/themePark_icons/bekal.svg", altText: "Bekal" },
    { imgSrc: "/assets/themePark_icons/wtfun.svg", altText: "WTFun" },
    { imgSrc: "/assets/themePark_icons/tamil.svg", altText: "Tamil Nadu Tourism" },
    { imgSrc: "/assets/themePark_icons/telangana.svg", altText: "Telangana Tourism" },
    { imgSrc: "/assets/themePark_icons/odisha.svg", altText: "Odisha Tourism" },
    { imgSrc: "/assets/themePark_icons/bengaluru.svg", altText: "Bengaluru Tourism" },
    { imgSrc: "/assets/themePark_icons/mojoland.svg", altText: "Mojoland" },
    { imgSrc: "/assets/themePark_icons/hpca.svg", altText: "HPCA" },
]

const EntertainmentClientsMarquee = ({ mobileView = false }) => {
    const clients = entertainmentClients.map((client) => ({
        ...client,
        height: mobileView ? "8rem" : "10rem",
        width: "15rem",
    }))

    if (mobileView) {
        return (
            <div style={{ marginTop: "2rem", position: "relative", zIndex: 1 }}>
                <NewMarqueeComponentHomePageIndia
                    speed={100}
                    ClientsArr={clients}
                    style={{ width: "100%", backgroundColor: "transparent", margin: "0rem auto" }}
                />
            </div>
        )
    }

    return (
        <div style={{ maxWidth: "1850px", margin: "0 auto" }}>
            <div style={{ margin: "0rem 10rem 0 10rem", position: "relative", zIndex: 1 }}>
                <NewMarqueeComponentHomePageIndia
                    speed={100}
                    ClientsArr={clients}
                    style={{
                        width: "100%",
                        backgroundColor: "transparent",
                        display: "flex",
                        justifyContent: "center",
                        margin: "2rem auto",
                    }}
                />
            </div>
        </div>
    )
}

export default EntertainmentClientsMarquee
